import useScript from './hook';
import useBeacon from './beacon';
import usePrivy from './privy';
import useOneTap from './oneTap';

export { useScript, usePrivy, useBeacon, useOneTap };
